import React from 'react';
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Switch,
  SwitchProps,
  Text,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';

interface SwitchInputFormProps extends SwitchProps {
  name: string | undefined | any;
  label: string | undefined;
  onClick?: any;
  errors: any;
  control: any;
  subLabel?: string;
}

export const SwitchInputForm = ({
  name,
  label,
  onClick,
  errors,
  control,
  subLabel,
  ...rest
}: SwitchInputFormProps) => {
  const { onChange: externalOnChange, ...switchProps } = rest;

  return (
    <FormControl isInvalid={!!errors[name]}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Flex as="label" htmlFor={name} align="center" gap="10px" h="38px" cursor="pointer">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Switch
              {...switchProps}
              id={name}
              onChange={(e) => {
                field.onChange(e.target.checked);
                if (typeof externalOnChange === 'function') {
                  externalOnChange(e);
                }
                if (onClick) {
                  onClick();
                }
              }}
              isChecked={!!field.value}
            />
          )}
        />
        <Text fontSize="13px" lineHeight="20px" color="content.body">
          {!subLabel ? 'Ativo' : subLabel}
        </Text>
      </Flex>
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
